var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ArticleDetail',{attrs:{"articleId":_vm.id,"pageTitle":_vm.pname,"categoryId":_vm.pid,"listPath":"/latestbroadcast","detailPath":"/latestbroadcast/latestdetail","showCover":false,"showMeta":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }